import React from 'react';
import styled, { css } from 'styled-components';

import Box from 'components/Box';
import Icon from 'components/Icon';
import {
  bodyMicroText,
  colors,
  fontWeights,
  mediaRetina,
  transition,
} from 'theme';

import { PrimaryButtonLink } from './PrimaryButtonLink';

const authButtonStyles = css<{
  size: string;
  $type: string;
  $danger?: boolean;
}>`
  ${(props) =>
    props.size !== 'large'
      ? `
    ${
      props.$type === 'google'
        ? `padding-left: 12px;`
        : `
      padding: 7px 16px 7px 9px;`
    };
    ${bodyMicroText}
    font-weight: ${fontWeights.semiBold};
  `
      : `
    height: 47px;
    `};
  background: white;
  color: ${(props) => (props.$danger ? colors.scarlet : colors.battleshipGrey)};
  box-shadow: 0 0 0 1px
    ${(props) => (props.$danger ? colors.scarlet : colors.aluminum)} inset;
  svg {
    transition: fill ${transition};
  }
  &:hover,
  &:focus {
    color: ${(props) => (props.$danger ? 'white' : colors.battleshipGrey)};
    background: ${(props) =>
      props.$danger ? colors.scarlet : colors.platinum};
    box-shadow: 0 0 0 1px
      ${(props) => (props.$danger ? colors.scarlet : colors.battleshipGrey)}
      inset;
    &[disabled] {
      background: white;
      color: ${(props) =>
        props.$danger ? colors.scarlet : colors.battleshipGrey};
      box-shadow: 0 0 0 1px
        ${(props) => (props.$danger ? colors.scarlet : colors.aluminum)} inset;
    }
    ${(props) =>
      props.$danger
        ? `
    &:not([disabled]) {
      svg {
        * {
          fill: white;
        }
      }
    }
    `
        : ''}
  }
  ${mediaRetina} {
    box-shadow: 0 0 0 1.5px
      ${(props) => (props.$danger ? colors.scarlet : colors.aluminum)} inset;
    &:hover,
    &:focus {
      box-shadow: 0 0 0 1.5px
        ${(props) => (props.$danger ? colors.scarlet : colors.battleshipGrey)}
        inset;
      &[disabled] {
        box-shadow: 0 0 0 1.5px
          ${(props) => (props.$danger ? colors.scarlet : colors.aluminum)} inset;
      }
    }
  }
`;
export const FacebookButton = styled(({ children, ...props }) => (
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/jsx-props-no-spreading
  <PrimaryButtonLink {...props} pl="6px" rel="nofollow">
    <Box width={1} display="flex" alignItems="center" justifyContent="center">
      <Icon name="facebook-new" width={22} height={22} />
      <Box ml={12}>{children || getText('Continue with Facebook')}</Box>
    </Box>
  </PrimaryButtonLink>
))`
  ${authButtonStyles};
`;

export const GoogleButton = styled(({ children, ...props }) => (
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/jsx-props-no-spreading
  <PrimaryButtonLink {...props} rel="nofollow">
    <Box width={1} display="flex" alignItems="center" justifyContent="center">
      <Icon name="google" width={20} height={20} />
      <Box ml={12}>{children || getText('Continue with Google')}</Box>
    </Box>
  </PrimaryButtonLink>
))`
  ${authButtonStyles};
`;
